import buildUrl from "../utils/buildUrl"

const Settings = {
  siteKey: process.env.REACT_APP_API_CAPTCHA_SITE_KEY,
  urls: {
    apiUsers: process.env.REACT_APP_API_ONBOARDING_BFF_URL
  },
  path: {
    sellers: `sellers`,
    resend: `sellers/resend-email`
  },
  buildUrl: (
    url = null,
    path = null,
    queryParams = null,
    hash = null,
    lowerCase = false,
    disableCSV = false
  ) =>
    buildUrl(url, {
      path,
      hash,
      lowerCase,
      disableCSV,
      queryParams
    })
}

export default Settings
